import useOnMouseAndScroll from '@shared/hooks/useOnMouseAndScroll'
import PropTypes from 'prop-types'

function LazyLoad({ children }) {
  const { isLoaded } = useOnMouseAndScroll()

  if (isLoaded) return children
  else return null
}
LazyLoad.propTypes = {
  children: PropTypes.node.isRequired
}
export default LazyLoad
